import React from 'react';
import { Card } from 'primereact/card';
import { Rating } from 'primereact/rating';
import { Avatar } from 'primereact/avatar';
import { BUSINESS_FIELDS } from '../constants';
import styles from '../style.module.css';

/**
 * Business List Item Component
 * Displays a single business in the search results list
 * 
 * @param {Object} props - Component props
 * @param {Object} props.business - Business data to display
 * @param {boolean} [props.isSelected] - Whether this item is currently selected
 * @param {Function} [props.onClick] - Callback when the item is clicked
 * @returns {JSX.Element} Business list item component
 */
const BusinessListItem = ({ business, isSelected = false, onClick }) => {
  if (!business) return null;

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) onClick(business);
  };

  const itemClass = `${styles.suggestionItem} ${isSelected ? styles.active : ''}`;
  const rating = business[BUSINESS_FIELDS.RATING] || 0;
  const reviewCount = business[BUSINESS_FIELDS.REVIEW_COUNT] || 0;
  const categories = business[BUSINESS_FIELDS.CATEGORIES] || [];
  const address = business[BUSINESS_FIELDS.ADDRESS] || 'No address provided';
  const imageUrl = business[BUSINESS_FIELDS.STORE_IMAGE];
  const shopName = business[BUSINESS_FIELDS.SHOP_NAME];

  return (
    <div className={itemClass} onClick={handleClick}>
      <div className="flex align-items-center">
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={shopName} 
            className="w-3rem h-3rem mr-3 border-circle object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'path/to/default-avatar.png';
            }}
          />
        ) : (
          <Avatar 
            icon="pi pi-building" 
            className="mr-3" 
            size="large" 
            shape="circle"
          />
        )}
        
        <div className="flex-1">
          <div className="font-medium">{shopName}</div>
          <div className="text-sm text-500 mb-1">
            {categories.slice(0, 2).join(' • ')}
            {categories.length > 2 && ' • ...'}
          </div>
          
          {/* <div className="flex align-items-center">
            <Rating 
              value={rating} 
              readOnly 
              cancel={false} 
              className="mr-2" 
              style={{ fontSize: '0.875rem' }}
            />
            <span className="text-xs text-500">
              {rating.toFixed(1)} ({reviewCount})
            </span>
          </div> */}
          
          <div className="text-xs text-500 flex align-items-center mt-1">
            <i className="pi pi-map-marker mr-1"></i>
            <span className="line-clamp-1">{address}</span>
          </div>
        </div>
        
        <i className="pi pi-chevron-right text-500"></i>
      </div>
    </div>
  );
};

export default BusinessListItem;
